import { BaseModel } from "../base-model";

export interface IDemandMult {
  DemandId?: number;
  FieldType?: number;
  Id?: number;
  Main?: boolean;
  Value?: number;
}
export class DemandMult extends BaseModel<IDemandMult> implements IDemandMult {
  DemandId: number;
  FieldType: number;
  Id: number;
  Main: boolean;
  Value: number;
  /**
   *
   */
  constructor(option?: IDemandMult) {
    super(option);
  }
}